<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="aboutUs">
				<div class="tabbar">
					<div class="item" @click="barClick(index)" :class="{ active: count == index }" v-for="(item, index) in list">
						<!-- <div class="txt">{{ item.menuName }}</div> -->
						<div class="line"></div>
					</div>
				</div>
				<div class="body" v-show="count == 0">
					<div id="map" style="width: 8.933333rem; height: 6.666667rem; margin-top: 0.266667rem"></div>
					<div class="info">
						<div class="companyName">{{ info.companyName }}</div>
						<div class="address">
							<div class="key">地址：</div>
							<div class="value">{{ info.address }}</div>
						</div>
						<div class="address">
							<div class="key">邮编：</div>
							<div class="value">{{ info.dawk }}</div>
						</div>
						<div class="address address1" v-for="(item, index) in info.phone">
							<div class="key">{{ item.key }}：</div>
							<div class="value">{{ item.value }}</div>
						</div>
						<div class="address">
							<div class="key">传真：</div>
							<div class="value">{{ info.fax }}</div>
						</div>
					</div>
				</div>
				<div class="body" v-show="count == 1" v-html="formatRichText(text)"></div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="aboutUs">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" />
						<span @click="toTopImg()" style="cursor: pointer">首页</span>
						<span style="color: black">></span>
						<span>联系我们</span>
						<span style="color: black">></span>
						<span>{{ list[count] ? list[count].menuName : '' }}</span>
					</div>
				</div>
				<div class="main">
					<div class="left">
						<div class="top">联系我们</div>
						<div v-for="(item, index) in list" class="bar" :class="{ bar1: count == index }" @click="barClick(index)">{{ item.menuName }}</div>
					</div>
					<div class="right" v-show="count == 0">
						<div id="map" style="width: 400px; height: 400px; margin-top: 20px; margin-left: 20px"></div>
						<div style="margin-top: 40px; margin-left: 40px">
							<div class="companyName">{{ info.companyName }}</div>
							<div class="address" style="font-size: 16px">地址：{{ info.address }}</div>
							<div class="address" style="font-size: 16px">邮编：{{ info.dawk }}</div>
							<div class="address address1" v-for="(item, index) in info.phone">
								<div>{{ item.key }}</div>
								<div>{{ item.value }}</div>
							</div>
							<div class="address">传真：{{ info.fax }}</div>
						</div>
					</div>
					<!-- 富文本 -->
					<div class="right ftRight" v-show="count == 1" v-html="formatRichText(text)"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { contactUs, singleinfo, menu } from '../api/api';
export default {
	name: 'aboutUsTemplate',
	data() {
		return {
			// list: ['投资者关系','联系我们'], //二级菜单数组
			list: [], //二级菜单数组
			parentId: this.$route.query.parentId || '', //二级菜单数组id
			count: 0,
			info: {},
			text: '' //富文本内容
		};
	},
	created() {
		this.getList(); //二级菜单
	},
	watch: {
		$route(to, from) {
			this.count = to.query.num;
			this.barClick(to.query.num);
		}
	},
	methods: {
		//富文本
		getSingleinfo(id) {
			console.log('id: ', id);
			singleinfo(id).then((res) => {
				this.text = res.data.content;
				console.log('getSingleinfo', res);
			});
		},
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			});
		},
		//二级菜单
		getList() {
			menu(this.parentId).then((res) => {
				this.list = res.data;
				console.log('this.list: ', this.list);
				console.log(this.$route.query.num, 'this.$route.query.num');
				// if (this.$route.query.num == 0) {
				// 	this.count = this.$route.query.num
				// 	this.getSingleinfo(res.data[this.$route.query.num].cmsLink) //富文本
				// }
				if (this.$route.query.num == 0) {
					this.count = this.$route.query.num;
					this.getContactUs();
				}
			});
		},
		getContactUs() {
			contactUs().then((res) => {
				this.info = res.data;
				this.info.phone = JSON.parse(this.info.phone);
				setTimeout(() => {
					this.initMap();
				}, 1000);
			});
		},
		barClick(index) {
			this.count = index;
			if (index == 0) {
				this.getSingleinfo(this.list[index].cmsLink); //富文本
			}
			if (index == 1) {
				this.getContactUs();
			}
		},
		//地图
		initMap() {
			// let map = ''
			let map = new AMap.Map('map', {
				//设置地图容器id
				viewMode: '2D', //是否为3D地图模式
				zoom: 16, //初始化地图缩放级别
				center: [this.info.lng, this.info.lat] //初始化地图中心点位置
			}).add(
				new AMap.Marker({
					map: map,
					position: [this.info.lng, this.info.lat], // 和上面的center 一样的
					offset: new AMap.Pixel(-15, -30),
					icon: new AMap.Icon({
						size: new AMap.Size(64, 64), // 图标尺寸
						// image: require("../assets/contact_addr.png"), // Icon的图像
						imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量
						imageSize: new AMap.Size(30, 30) // 根据所设置的大小拉伸或压缩图片，一般不用
					})
				})
			);
		}
	}
};
</script>

<style scoped lang="scss">
.device-mobile {
	.aboutUs {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-bottom: 0.533333rem;

		.tabbar {
			width: 9.466667rem;
			height: 1.653333rem;
			display: flex;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.4rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007cc3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.body {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 9.466667rem;
			background: #ffffff;
			box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.info {
				width: 8.733333rem;
				padding: 0.533333rem 0;

				.companyName {
					font-size: 0.426667rem;
					font-family: Microsoft YaHei-Bold, Microsoft YaHei;
					font-weight: bold;
					color: #000000;
				}

				.address {
					display: flex;
					margin-top: 0.333333rem;
					font-size: 0.346667rem;
					font-family: Microsoft YaHei-Regular;
					font-weight: 400;
					color: #000000;

					.key {
						white-space: nowrap;
					}
				}
				.address1 {
					// width: 480px;
					display: flex;
					flex-wrap: wrap;
					margin-top: 0;
					div {
						min-width: 50%;
						margin-top: 0.333333rem;
					}
					// justify-content: space-between;
					// padding-right: 10px;
					// flex-wrap: wrap;
					// line-height: 50px;
				}
			}
		}
	}
}

.device-pc {
	.aboutUs {
		width: 100vw;
		// display: flex;
		// justify-content: center;
		background: #f5f5f5;
		padding-bottom: 50px;
	}

	.main {
		display: flex;
		width: 1300px;
		margin: 0 auto;
		padding-top: 25px;
	}

	.left {
		// background: #FFFFFF;

		.top {
			width: 270px;
			height: 64px;
			background: url('../assets/bannerImg.png') no-repeat;
			background-size: 100%;
			font-size: 26px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #ffffff;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.bar {
			width: 270px;
			height: 48px;
			background: #ffffff;
			border-bottom: 1px solid #ededed;
			font-size: 18px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			cursor: pointer;
		}

		.bar1 {
			font-size: 18px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #0175c2;
			border-bottom: 1px solid #0175c2;
		}
	}

	.ftRight {
		padding: 20px;
		p img {
			text-indent: 0 !important;
		}
	}

	.right {
		width: 925px;
		margin-left: 10px;
		height: 342px;
		background: #ffffff;
		display: flex;
		min-height: 600px;

		.companyName {
			font-size: 20px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #000000;
			line-height: 30px;
		}

		.address {
			font-size: 15px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: 500;
			color: #000000;
			line-height: 30px;
			// margin-top: 5px;
			white-space: pre-wrap;
		}

		.address1 {
			width: 480px;
			display: flex;
			flex-wrap: wrap;
			div {
				min-width: 50%;
				box-sizing: border-box;
				padding-right: 5px;
			}
			// justify-content: space-between;
			// padding-right: 10px;
			// flex-wrap: wrap;
			// line-height: 50px;
		}
	}

	.navigation {
		width: 100vw;
		background: #fff;
		display: flex;
		align-items: center;

		.navigationItem {
			width: 1300px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			// margin-top: 15px;
			height: 36px;
			line-height: 36px;
			margin-bottom: 20px;
			padding-top: 15px;
			box-sizing: border-box;
			color: #1979b7;
			font-size: 20px;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue